import React from "react";
import "./styles/FAQPage.css";
import { motion } from "framer-motion";

const faqSections = [
  {
    title: "1. Регистрация и вход",
    content: `После регистрации вы можете войти в систему с помощью имени пользователя и пароля. При включенной двухфакторной аутентификации потребуется также ввести код подтверждения.`,
  },
  {
    title: "2. Профиль пользователя",
    content: `Вы можете изменить аватар, указать информацию о себе, добавить бейджи, а также включить/отключить комментарии и анимации.`,
  },
  {
    title: "3. Оценки и зачётная книжка",
    content: `Просматривайте свои оценки по предметам в журнале. Также доступна зачётная книжка с финальными отметками по дисциплинам.`,
  },
  {
    title: "4. Домашние задания",
    content: `Смотрите и выполняйте задания в разделе \"Домашние задания\". При наличии подписки можно использовать проверку ИИ.`,
  },
  {
    title: "5. Новости и уведомления",
    content: `Читайте важные объявления от администрации. Новые публикации отображаются в колокольчике с уведомлением.`,
  },
  {
    title: "6. Премиум-функции",
    content: `Подписка открывает доступ к автопроверке ДЗ ИИ, статистике, дополнительным визуальным темам и другим функциям.`,
  },
  {
    title: "7. Поиск",
    content: `Через поиск можно находить других пользователей, группы, ДЗ и новости.`,
  },
];

const FAQPage = () => {
  return (
    <div className="faq-container">
      <h1>FAQ</h1>
      {faqSections.map((section, index) => (
        <motion.div
          key={index}
          className="faq-section"
          initial={{ opacity: 0, y: 10, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: -10, scale: 0.95 }}
          transition={{
            type: "spring",
            stiffness: 200,
            damping: 25,
            bounce: 0.5,
            delay: index * 0.1,
          }}
        >
          <h2>{section.title}</h2>
          <p>{section.content}</p>
        </motion.div>
      ))}
    </div>
  );
};

export default FAQPage;
